// A13 regression: highlight + aria-expanded must track the item whose panel is OPEN,
// resolved by id (same source as the rendered panel), not the raw list index. When a
// PRECEDING item is removed the indices shift for one render before the repair effect
// re-points openedPanelIndex; during that commit an index-based marker highlights the
// wrong row / sets aria-expanded on the wrong trigger. This test observes that commit
// by rendering the shifted list WITHOUT act(), so the passive repair effect has not yet
// run (React 17 legacy render flushes passive effects asynchronously).

import React from 'react'
import { List, Map } from 'immutable'
import { render, unmountComponentAtNode } from 'react-dom'
import { act } from 'react-dom/test-utils'

import { DropdownMenu } from './dropdown-menu.jsx'

let container

const mkItem = id => Map({ id, text: id, panel: () => <div data-testid={`panel-${id}`}>{id}</div> })

const rows = () => Array.from(container.querySelectorAll('.rfd-ui-dropdown-menu-item'))
const rowByText = label => rows().find(a => a.querySelector('.rfd-ui-dropdown-menu-item-text').textContent === label)

beforeEach(() => {
  container = document.createElement('div')
  document.body.appendChild(container)
})

afterEach(() => {
  act(() => {
    unmountComponentAtNode(container)
  })
  container.remove()
})

test('highlight + aria-expanded follow the open item by id when a preceding item is removed', () => {
  const initial = List([mkItem('a'), mkItem('b'), mkItem('c')])

  act(() => {
    render(<DropdownMenu items={initial} />, container)
  })

  // Open b's panel (index 1).
  act(() => {
    rowByText('b').click()
  })
  expect(rowByText('b').getAttribute('aria-expanded')).toBe('true')
  expect(rowByText('b').classList.contains('itemOpened')).toBe(true)

  // Remove the preceding item 'a' so indices shift: b -> 0, c -> 1. Rendered WITHOUT act
  // so the repair effect has not yet corrected openedPanelIndex (still 1, now pointing at c).
  const shifted = List([mkItem('b'), mkItem('c')])
  render(<DropdownMenu items={shifted} />, container)

  // The open panel is still b's; highlight + aria-expanded must stay on b, not leak to c.
  expect(rowByText('b').classList.contains('itemOpened')).toBe(true)
  expect(rowByText('b').getAttribute('aria-expanded')).toBe('true')
  expect(rowByText('c').classList.contains('itemOpened')).toBe(false)
  expect(rowByText('c').getAttribute('aria-expanded')).toBe('false')
})
